import React, { Component } from "react";
import FpgPlusIcon from "../icons/fpgplusicon";
import CatEditIcon from "../icons/catediticon";
import TextField from "../component/TextField";
import CheckBox from "../component/CheckBox";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//Service import
import service from "../services";
import Loader from "../component/loader";
import TablistGenre from "./TablistGenre";

let sub;
class TALKEVENTSGenre extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      name: "",
      description: "",
      loaderFlag: false,
      changeTalkEventsGenreTitleName: false,
      getAllTalkEventsGenreDetails: [],
      getAllTalkEventsGenreDocs: [],
      id: "",
      eventiveId: '',
      showTags: true,
      showFilters: true,
      showFPG: true,
      isEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }

  // Shared default values for the add/edit form fields.
  defaultFormState = () => ({
    name: "",
    description: "",
    eventiveId: '',
    showTags: true,
    showFilters: true,
    showFPG: true,
  });

  AddCategory = () => {
    this.validator.hideMessages("");
    this.setState({
      addCatmodal: true,
      ...this.defaultFormState(),
      isEdited: true
    });
  };
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      changeTalkEventsGenreTitleName: false,
      id: '',
      ...this.defaultFormState(),
      isEdited: false
    });
    this.validator.hideMessages("");
  };
  componentDidMount = async () => {
    this.getAllTalkEventsGenre();
    this.getTalkEventsGenre();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getTalkEventsGenre = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "beyondFilm|eventTypes|getList":
          this.setState(
            {
              getAllTalkEventsGenreDetails: response.data,
              getAllTalkEventsGenreDocs: response.data.docs,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "beyondFilm|eventTypes|add":
          this.handleSaveResponse(response, "Events type created successful.");
          break;
        case "beyondFilm|eventTypes|edit":
          this.handleSaveResponse(response, "Events type updated Successful.");
          break;
        default:
          break;
      }
    });
  };

  getAllTalkEventsGenre = () => {
    this.apiserve.sendevent("beyondFilm|eventTypes|getList", {});
  };

  // Shared success/error handling for the add & edit responses.
  handleSaveResponse = (response, successMsg) => {
    if (response.error === true) {
      this.setState({
        loaderFlag: false,
        errorMsg: true,
        errorMsgShow: response.data.error,
      });
    } else {
      this.setState(
        {
          addCatmodal: false,
          changeTalkEventsGenreTitleName: false,
          loaderFlag: false,
          ...this.defaultFormState(),
        },
        () => this.apiserve.success(successMsg)
      );
    }
    this.getAllTalkEventsGenre();
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  handleChecked = (e) => {
    this.updateState({
      [e.target.name]: e.target.checked,
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  submitFn = (e) => {
    e.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }
    this.setState({ loaderFlag: true });
    const { name, description, eventiveId, showTags, showFilters, showFPG, id, changeTalkEventsGenreTitleName } = this.state;
    const data = { name, description, eventiveId, showTags, showFilters, showFPG };
    if (changeTalkEventsGenreTitleName) {
      this.apiserve.sendevent("beyondFilm|eventTypes|edit", { ...data, eventTypeId: id });
    } else {
      this.apiserve.sendevent("beyondFilm|eventTypes|add", data);
    }
  };

  editGenreUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeTalkEventsGenreTitleName: true,
      name: item.name,
      description: item.description,
      id: item._id,
      eventiveId: item.eventiveId ? item.eventiveId : '',
      showTags: item.showTags,
      showFilters: item.showFilters,
      showFPG: item.showFPG !== undefined ? item.showFPG : true,
      isEdited: false
    });
    this.validator.hideMessages("");
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  render() {
    const { getAllTalkEventsGenreDocs, changeTalkEventsGenreTitleName, isEdited } = this.state;
    const isSaveDisabled = changeTalkEventsGenreTitleName && !isEdited;
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <TablistGenre active={1} ref={this.tablistRef} />
          <div className="cat_outer_content">
            <div className="category_add_edit">
              <div className="category_header relative">
                <p>Events Type </p>
                <span className="add_icon d_flex" onClick={this.AddCategory}>
                  <FpgPlusIcon
                    width="16"
                    height="16"
                    color="#ffffff"
                    stroke="#4F4F4F"
                  />
                </span>
              </div>
              <div className="list_wrap striped_droppable_table">
                <ul>
                  {getAllTalkEventsGenreDocs?.map((item) => (
                    <li
                      key={item._id}
                      className="pointer d_flex d_flex_align_center"
                    >
                      <p className="cat_name">{item.name}</p>
                      <div className="action d_flex d_flex_align_center">
                        <span
                          className="cat_edit pointer"
                          onClick={() => this.editGenreUser(item)}
                        >
                          <CatEditIcon />
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
          >
            <span className="popup_overlay" onClick={this.CloseModal}></span>
            <div className="cat_modal_inner">
              <p className="cat_title text_center">
                {changeTalkEventsGenreTitleName ? "Edit Events Type" : "Events Type"}
              </p>
              <form>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Genre Name"
                    name="name"
                    value={this.state.name}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Genre Name",
                      this.state.name,
                      "required"
                    )}
                  />
                </div>
                <div className="field_row horizontal_field d_flex">
                  <label>Genre Description</label>
                  <div className="textarea_wrap">
                    <textarea
                      type="text"
                      rows="12"
                      name="description"
                      value={this.state.description}
                      onChange={this.onInputChange}
                    ></textarea>
                    <span style={{ color: "red" }}>
                      {this.validator.message(
                        "Description",
                        this.state.description,
                        "required"
                      )}
                    </span>
                  </div>
                </div>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Eventive ID"
                    name="eventiveId"
                    value={this.state.eventiveId}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Eventive ID",
                      this.state.eventiveId,
                      "required"
                    )}
                  />
                </div>
                <div className="field_row">
                  <CheckBox
                    label="Include In Tags"
                    type="checkbox"
                    id="showTags"
                    name="showTags"
                    checked={this.state.showTags}
                    onChange={this.handleChecked}
                  />
                </div>
                <div className="field_row">
                  <CheckBox
                    label="Include In Filters"
                    type="checkbox"
                    id="showFilters"
                    name="showFilters"
                    checked={this.state.showFilters}
                    onChange={this.handleChecked}
                  />
                </div>
                <div className="field_row">
                  <CheckBox
                    label="Display on FPG"
                    type="checkbox"
                    id="showFPG"
                    name="showFPG"
                    checked={this.state.showFPG}
                    onChange={this.handleChecked}
                  />
                </div>
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.CloseModal}>
                    CANCEL
                  </button>
                  <button
                    className={isSaveDisabled ? "disabled" : "active"}
                    disabled={isSaveDisabled}
                    onClick={this.submitFn}
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default TALKEVENTSGenre;
